<script setup>
import {ref, onMounted, computed} from 'vue'
import {getServiceTypes} from "@/services/api/serviceTypes.js";
import {useCustomerStore} from "@/stores/checkinStore.js";
import {saveTotemTicket} from "@/services/api/TotemTickets.js";
import { useRouter } from 'vue-router'

const currentStep = 2
const totalSteps = 3

const progress = (currentStep / totalSteps) * 100
const options = ref([])
const loading = ref(false)
const store = useCustomerStore()
const router = useRouter();

function cancelarAtendimento() {
    store.clearCustomer();

    router.push('/kiosk');
}

const loadServiceTypes = async () => {
    loading.value = true
    try {
        const response = await getServiceTypes({ limit: 4 })

        options.value = response.data.map(item => ({
            id: item.id,
            title: item.name,
            description: item.description,
            icon: item.icon || 'tag'
        }))

    } catch (error) {
        console.error('Erro ao buscar tipos de serviço:', error)
    } finally {
        loading.value = false
    }
}

async function onSaveTicket() {
    await saveTotemTicket(store.customer)
    router.push("/display");
}

const selectServiceType = (id) => {
    store.customer = {
        ...store.customer,
        checkin_service_type_id: id,
        status: true
    };
    onSaveTicket();
};

onMounted(() => {
    loadServiceTypes()
})

</script>
<template>
    <div class="container">

        <!-- Header -->
        <header class="header">
            <div class="top">
                <span class="title">CHECK-IN</span>
                <span class="step">Etapa 2 de 3</span>
            </div>

            <div class="progress">
                <div class="progress-bar" :style="{ width: progress + '%' }"></div>
            </div>
            <h2>Olá, {{store?.customer?.customer_name.split(" ")[0]}}! Como podemos te ajudar hoje?</h2>
            <p>Selecione o tipo de atendimento para iniciar seu atendimento.</p>
        </header>

        <!-- Options -->
        <div class="list">
            <v-card
                v-for="option in options"
                :key="option.id"
                class="card"
                @click="selectServiceType(option.id)"
            >

                <v-card-item class="pb-0">
                    <div class="icon">
                        <i :class="`mdi ${option.icon} icon`"></i>
                    </div>
                </v-card-item>
                <v-card-text class="ps-2 py-0">
                    <h3>{{ option.title }}</h3>
                    <p>{{ option.description }}</p>
                </v-card-text>

            </v-card>
            <v-row class="d-flex justify-center mt-20">
                <v-col class="d-flex justify-center" cols="8">
                    <v-btn
                        block
                        rounded="xl"
                        size="small"

                        class="text-none d-flex justify-center"
                        style="font-size:12px!important; background-color:#f1f5f9!important;color:#1f7a8c;"
                        @click="cancelarAtendimento"
                    >
                        <i class="mdi mdi-close-circle-outline"></i>
                        CANCELAR ATENDIMENTO
                    </v-btn>
                </v-col>
            </v-row>

        </div>

    </div>
</template>


<style scoped>

.page {
    min-height: 100vh;
    background: #f8fafc;
    padding: 20px 16px;
    color: #0f172a;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, Cantarell, sans-serif;
}

.header {
    margin-bottom: 18px;
}

.top {
    margin-top:10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title {
    font-size: 12px;
    font-weight: 700;
    color: #0891b2;
    letter-spacing: .06em;
}

.step {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
}

/* Progress bar */
.progress {
    width: 100%;
    height: 6px;
    border-radius: 99px;
    background: #e5e7eb;
    overflow: hidden;
    margin-bottom: 14px;
}

.progress-bar {
    height: 100%;
    background: #0891b2;
    border-radius: 99px;
    transition: width .3s ease;
}

h1 {
    font-size: 22px;
    margin: 6px 0 6px;
}

.header p {
    font-size: 14px;
    color: #64748b;
}


/* Cards */
.list {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.card {
    display: flex;
    gap: 14px;
    padding: 16px;
    border-radius: 18px;
    background: #ffffff;
    border: none;
    text-align: left;
    cursor: pointer;
    transition: all .15s ease;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
}

.icon {
    width: 56px;
    height: 56px;
    font-size: 35px;
    border-radius: 14px;
    background: #e0f2fe;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0891b2;
}

.material-symbols-outlined.solid {
    font-variation-settings: 'FILL' 1;
    font-size: 26px;
}

.text h3 {
    font-size: 16px;
    margin: 0;
}

.text p {
    font-size: 13px;
    margin-top: 3px;
    color: #64748b;
}
</style>
